"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(exports, "__esModule", { value: true });
const vue_property_decorator_1 = require("vue-property-decorator");
const timers_1 = require("timers");
let CircularCountDown = class CircularCountDown extends vue_property_decorator_1.Vue {
    constructor() {
        super(...arguments);
        this.timeLeft = this.time;
    }
    startCountDown() {
        this.timer = (0, timers_1.setInterval)(() => {
            this.timeLeft--;
            if (this.timeLeft <= 0) {
                this.stopCountDown();
            }
        }, 1000);
    }
    stopCountDown() {
        clearInterval(this.timer);
        this.$emit('finished');
    }
    mounted() {
        if (this.running) {
            this.startCountDown();
        }
    }
};
__decorate([
    (0, vue_property_decorator_1.Prop)({ type: String, default: 'primary' })
], CircularCountDown.prototype, "accentGlobal", void 0);
__decorate([
    (0, vue_property_decorator_1.Prop)({ type: String, default: '100%' })
], CircularCountDown.prototype, "width", void 0);
__decorate([
    (0, vue_property_decorator_1.Prop)({ type: String, default: '100%' })
], CircularCountDown.prototype, "height", void 0);
__decorate([
    (0, vue_property_decorator_1.Prop)({ type: String, default: '' })
], CircularCountDown.prototype, "title", void 0);
__decorate([
    (0, vue_property_decorator_1.Prop)({ type: Number, default: 5 })
], CircularCountDown.prototype, "time", void 0);
__decorate([
    (0, vue_property_decorator_1.Prop)({ type: Boolean, default: false })
], CircularCountDown.prototype, "running", void 0);
CircularCountDown = __decorate([
    (0, vue_property_decorator_1.Options)({
        components: {},
    })
], CircularCountDown);
exports.default = CircularCountDown;
